<template>
  <div class="character">
    <div class="module">
      <div class="title"></div>
      <div class="content">
        <div class="left">
          <div class="tab-progress">
            <div v-for="idx in 3" :key="idx" :class="'item idx-' + idx + (idx === tab ? ' active' : '')"></div>
          </div>
          <div class="tab-avatar">
            <div v-for="(item, key) in list" :key="key" class="item" @click="changeCharacter(key)">
              <img :src="tab === (key + 1) ? item.active : item.inactive" />
            </div>
          </div>
        </div>
        <div class="right">
          <div class="video-box">
            <video id="characterVideo" class="video" controls :key="videoKey" autoplay muted loop>
              <source :src="videoUrl" />
              您当前使用的浏览器不支持HTML5视频。
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      tab: undefined,
      videoUrl: '',
      videoKey: 1,
    }
  },
  watch: {
    list: function (val) {
      if (val.length > 0) this.changeCharacter(0)
    }
  },
  methods: {
    // 切换角色
    changeCharacter(idx) {
      // 点击当前角色不处理
      if (this.tab === idx + 1) return false

      this.tab = idx + 1
      this.videoUrl = this.list[idx].video
      this.videoKey++
    }
  },
}
</script>

<style lang="scss" scoped>
.character {
  width: 100%;
  height: 1075px;
  background: url('~@/assets/img/bg_module2.jpg') no-repeat;
  background-position: center;
}

.module {
  padding-top: 59px;
}

.title {
  background-position: 0 -155px;
}

.content {
  display: flex;
  margin-top: 20px;

  .left {
    display: flex;
  }

  .tab-progress {
    position: relative;
    margin: 96px 0 0 40px;
    width: 24px;
    height: 553px;
    background: url('~@/assets/img/avatar_tag_list.png') no-repeat;

    .item {
      position: absolute;
      width: 24px;
      height: 21px;
      background: url('~@/assets/img/avatar_tag.png') no-repeat;
      background-position: -24px 0;

      &.active {
        background-position: 0 0;
      }

      &.idx-1 {
        top: 45px;
      }
      &.idx-2 {
        top: 261px;
      }
      &.idx-3 {
        top: 485px; 
      }
    }
  }

  .tab-avatar {
    margin: 84px 0 0 19px;

    .item {
      margin-bottom: 83px;
      width: 167px;
      height: 137px;
      cursor: pointer;
    }
  }

  .right {
    margin-left: 50px;

    .video-box {
      width: 1224px;
      height: 750px;
      background: url('~@/assets/img/bg_video.png') no-repeat;

      .video {
        margin: 42px 0 0 49px;
        width: 1092px;
        height: 612px;
      }
    }
  }
}
</style>